import { cn } from "@/lib/utils";

type Props = {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  className?: string;
}

export default async function HeadingBlock({ title, subtitle, children, className }: Props) {
  return (
    <div className={cn("flex flex-col box-border", className)}>
      <div className="flex flex-row justify-center items-start mx-16 bg-babyBlue rounded-3xl rounded-b-none p-12">
        <h1>{title}</h1>
        {subtitle && <div className="font-roboto font-semibold italic text-sm lg:text-2xl">{subtitle}</div>}
      </div>
      <div className="rounded-3xl bg-secondary p-12 mx-[-4rem] box-border">
        {children}
      </div>
    </div>
  )
}

export function HeadingBlockTitle({ title, subtitle }: Pick<Props, "title" | "subtitle">) {
  return (
    <div className="flex flex-col box-border justify-center items-center bg-babyBlue rounded-4xl rounded-b-none p-4 lg:p-12">
      <h1 className="mb-4">{title}</h1>
      {subtitle && <div className="font-roboto font-semibold italic text-center text-sm lg:text-xl xxl:text-2xl">{subtitle}</div>}
    </div>
  )
}

export function HeadingBlockAction({ children, className }: { children: React.ReactNode, className?: string }) {
  return <div className={cn("rounded-3xl bg-secondary p-12 mx-[-2rem] lg:mx-[-4rem] box-border", className)}>
    {children}
  </div>
}